import { styled } from '@mui/material/styles';

export const Pages = styled('ul')({
	listStyle: 'none',
	padding: 0,
	margin: 0,
	display: 'flex',
	gap: '6px',
	justifyContent: 'center',
});

export const NextPrev = styled('button')(({ theme, disabled }) => ({
	border: 0,
	backgroundColor: 'transparent',
	padding: theme.spacing(1),
	cursor: disabled ? 'not-allowed' : 'pointer',
	color: disabled ? theme.palette.grey[500] : theme.palette.primary.main,
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	fontWeight: 800,
	fontSize: 'var(--font-size-small)',
	fontFamily: ['Open Sans', '"Helvetica Neue"', 'Arial', 'sans-serif'].join(','),
	'&:hover': {
		textDecoration: disabled ? 'none' : 'underline',
	},
}));

export const Page = styled('button')<{
	selected?: boolean;
}>(({ theme, selected, disabled }) => ({
	borderRadius: '5px',
	border: 'none',
	width: '33px',
	height: '33px',
	cursor: disabled ? 'not-allowed' : 'pointer',
	backgroundColor: selected ? theme.palette.primary.main : theme.palette.grey[200],
	color: disabled
		? theme.palette.grey[500]
		: selected
		? theme.palette.common.white
		: theme.palette.text.primary,
	fontWeight: selected ? 800 : undefined,
	'&:hover': {
		backgroundColor: !disabled ? theme.palette.primary.main : undefined,
		color: !disabled ? theme.palette.common.white : undefined,
		transition: 'background-color 0.3s',
	},
}));

export const Frame = styled('nav')<{
	isMobile: boolean;
}>(({ isMobile }) => ({
	display: 'flex',
	justifyContent: isMobile ? 'center' : 'space-between',
	alignItems: 'center',
}));
